import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  height: calc(100% - 56px);
  width: 100%;
  background-color: var(--primary-background-color);
`;
